export default {
	SET_CUSTOMER_TASKS: "SET_CUSTOMER_TASKS",
	CREATE_CUSTOMER_TASK: "CREATE_CUSTOMER_TASK",
	SET_LOADING: "SET_LOADING",
	SET_PAGE_INFO: "SET_PAGE_INFO",
	SET_FILTERS: "SET_FILTERS"
};